import React from 'react';

interface CTAStripProps {
  onOpenAuth: () => void;
}

export const CTAStrip: React.FC<CTAStripProps> = ({ onOpenAuth }) => {
  return (
    <section style={{
      background: 'var(--fs-surface-low)',
      borderTop: '1px solid var(--fs-border)',
      borderBottom: '1px solid var(--fs-border)',
      padding: '56px 20px',
    }}>
      <div style={{ maxWidth: 'var(--fs-max-width)', margin: '0 auto', textAlign: 'center' }}>
        <p className="fs-section-label" style={{ marginBottom: 12 }}>Early Access</p>
        <h2 style={{
          fontFamily: 'var(--fs-font-headline)',
          fontWeight: 700,
          fontSize: 'clamp(28px, 4vw, 36px)',
          color: 'var(--fs-text)',
          letterSpacing: '-0.02em',
          marginBottom: 16,
        }}>
          Be among the first to use FORMA Studio.
        </h2>
        <p style={{
          fontFamily: 'var(--fs-font-body)',
          fontSize: 15,
          color: 'var(--fs-text-muted)',
          marginBottom: 28,
          maxWidth: 440,
          marginLeft: 'auto',
          marginRight: 'auto',
        }}>
          Sign in to use the apps. Free account. No credit card.
        </p>
        <button className="fs-btn-primary" onClick={onOpenAuth}>Create Free Account</button>
      </div>
    </section>
  );
};
